import { render, staticRenderFns } from "./LinkWidget.vue?vue&type=template&id=334547df&scoped=true"
import script from "./LinkWidget.vue?vue&type=script&lang=js"
export * from "./LinkWidget.vue?vue&type=script&lang=js"
import style0 from "./LinkWidget.vue?vue&type=style&index=0&id=334547df&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334547df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('334547df')) {
      api.createRecord('334547df', component.options)
    } else {
      api.reload('334547df', component.options)
    }
    module.hot.accept("./LinkWidget.vue?vue&type=template&id=334547df&scoped=true", function () {
      api.rerender('334547df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/viewer/templateWidgets/LinkWidget.vue"
export default component.exports